import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../blocks/heigh-educate-banner";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../blocks/customer-detail-intro";
import { Footer } from "../../components/FooterV2";
import { CustomerDetailChallenge } from "../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";

export const SouthEastPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.dongnan.challenge.item1.title"),
      description: t("customer.dongnan.challenge.item1.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.dongnan.ideas.item1.title"),
      descript: t("customer.dongnan.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.dongnan.ideas.item2.title"),
      descript: t("customer.dongnan.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
  ];
  return (
    <div className="south-east-page">
      <Helmet>
        <title>
          东南大学SSO单点登录案例_东南大学统一身份认证案例-Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.dongnan.banner.title")}
        subtitle={t("customer.dongnan.banner.subtitle")}
        theme="#658256"
        imgUrl={
          "//files.authing.co/authing-website/customer-story-detail-banner-dongnan-tiny.png"
        }
        alt="东南大学身份管理方案"
      />
      <CustomerDetailIntro
        imgUrl={t("customer.dongnan.intro.imgUrl")}
        alt="教育行业身份安全"
        content={
          <>
            <p>{t("customer.dongnan.intro.descript1")}</p>
            <p>{t("customer.dongnan.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme="#658256" />
      <CustomerDetailIdea ideas={ideas} theme="#658256" />
      <CommonPageLink pagesLink={pagesLink} />

      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
